import { STATUS } from "@/constants/statuses";
import {
    reviewsApplicationLoggerToken,
    reviewsAuthApiClientToken,
} from "@apps/reviews/tokens";
import { applyTransaction } from "@datorama/akita";
import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { catchError, map, tap } from "rxjs";
import { create } from "superstruct";
import { inject, singleton } from "tsyringe";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import { ReviewsSummarySchema } from "../schemas/ReviewsSummarySchema";
import ReviewsSummaryStore from "../stores/ReviewsSummaryStore";

@singleton()
class ReviewsSummaryService {
    constructor(
        private readonly reviewsSummaryStore: ReviewsSummaryStore,
        @inject(reviewsAuthApiClientToken)
        private readonly authApiClient: ApiClientInterface,
        @inject(reviewsApplicationLoggerToken)
        private readonly logger: LoggerInterface
    ) {}

    getReviewsSummary() {
        this.logger.debug("ReviewsSummaryService.getReviewsSummary is started");
        this.reviewsSummaryStore.setStatus(STATUS.INITIAL_LOADING);
        return this.authApiClient
            .get({
                url: "/review/getReviewBadgeInfo",
            })
            .pipe(
                map((response) => create(response.body, ReviewsSummarySchema)),
                catchError((error: unknown) => {
                    this.logger.debug(
                        "ReviewsSummaryService.getReviewsSummary is errored",
                        { error }
                    );
                    applyTransaction(() => {
                        this.reviewsSummaryStore.setError(error);
                        this.reviewsSummaryStore.setStatus(STATUS.ERROR);
                    });
                    throw error;
                }),
                tap((v) => {
                    this.logger.debug(
                        "ReviewsSummaryService.getReviewsSummary is ready"
                    );
                    applyTransaction(() => {
                        this.reviewsSummaryStore.update({
                            summary: { count: v.count, avgRate: v.avgRate },
                        });
                        this.reviewsSummaryStore.setStatus(STATUS.READY);
                    });
                })
            );
    }
}

export default ReviewsSummaryService;
